import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import UsageTracker from '../../utils/UsageTracker';
import { useRegisterForSession } from './liveEventQueries';
import { getSessionStartTime } from './sessionTimeUtils';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
function SessionAlert({
  body,
  cta,
  title,
  type
}) {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(Alert, {
    "data-test-id": "live-event-registration-alert",
    marginBlock: "800",
    titleText: title,
    type: type,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: isMobile ? 'stretch' : 'center',
      flexDirection: isMobile ? 'column' : 'row',
      flexGrow: 1,
      gap: "400",
      inlineSize: "100%",
      justifyContent: "space-between",
      children: [body, cta]
    })
  });
}
const LiveSessionAlertBody = ({
  bodyMessage,
  liveSession
}) => /*#__PURE__*/_jsx(FormattedReactMessage, {
  message: bodyMessage,
  options: {
    startTime: /*#__PURE__*/_jsx(FormattedDateTime, {
      format: "LT",
      type: "userTz",
      value: getSessionStartTime(liveSession)
    })
  }
});
function RegisterLiveSessionButton({
  liveEventId,
  onRegistered,
  sessionId
}) {
  const {
    registerForSession,
    registrationLoading
  } = useRegisterForSession({
    onCompleted: onRegistered,
    onError: () => {
      FloatingAlertStore.addAlert({
        type: 'danger',
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.liveEventOverviewModal.registrationError"
        })
      });
    }
  });
  const handleRegister = () => {
    UsageTracker.trackStandalone('Learning Center Interaction', {
      action: 'live-event-register-click',
      contentType: 'LIVE_EVENT',
      contentId: liveEventId,
      sessionId
    });
    void registerForSession(sessionId);
  };
  return /*#__PURE__*/_jsx(LoadingButton, {
    loading: registrationLoading,
    onClick: handleRegister,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyComponents.liveEventOverviewModal.registerForWorkshop"
    })
  });
}
const LiveEventRegistrationAlert = ({
  hasRegisteredUpcoming,
  isLiveSessionRegistered,
  joinUrl,
  liveEventId,
  liveSession,
  onRegistered,
  pastRecording,
  viewRegisteredEventsTo
}) => {
  if (liveSession && isLiveSessionRegistered) {
    return /*#__PURE__*/_jsx(SessionAlert, {
      body: /*#__PURE__*/_jsx(LiveSessionAlertBody, {
        bodyMessage: "academyComponents.liveEventOverviewModal.alert.liveRegisteredBody",
        liveSession: liveSession
      }),
      cta: joinUrl ? /*#__PURE__*/_jsx(Button, {
        external: true,
        href: joinUrl,
        target: "_blank",
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.liveEventOverviewModal.joinSession"
        })
      }) : undefined,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyComponents.liveEventOverviewModal.alert.liveNowTitle"
      }),
      type: "success"
    });
  }
  if (liveSession) {
    return /*#__PURE__*/_jsx(SessionAlert, {
      body: /*#__PURE__*/_jsx(LiveSessionAlertBody, {
        bodyMessage: "academyComponents.liveEventOverviewModal.alert.liveUnregisteredBody",
        liveSession: liveSession
      }),
      cta: /*#__PURE__*/_jsx(RegisterLiveSessionButton, {
        liveEventId: liveEventId,
        onRegistered: onRegistered,
        sessionId: liveSession.id
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyComponents.liveEventOverviewModal.alert.liveNowTitle"
      }),
      type: "success"
    });
  }
  if (hasRegisteredUpcoming) {
    return /*#__PURE__*/_jsx(SessionAlert, {
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyComponents.liveEventOverviewModal.alert.upcomingRegisteredBody"
      }),
      cta: /*#__PURE__*/_jsx(RouterButton, {
        to: viewRegisteredEventsTo,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.liveEventOverviewModal.viewRegisteredEvents"
        })
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyComponents.liveEventOverviewModal.alert.registeredTitle"
      }),
      type: "info"
    });
  }
  if (pastRecording) {
    const body = pastRecording.attended ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyComponents.liveEventOverviewModal.alert.pastAttendedBody"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyComponents.liveEventOverviewModal.alert.pastRegisteredBody"
    });
    return /*#__PURE__*/_jsx(SessionAlert, {
      body: body,
      cta: /*#__PURE__*/_jsx(Button, {
        external: true,
        href: pastRecording.recordingUrl,
        target: "_blank",
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.liveEventOverviewModal.watchRecording"
        })
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyComponents.liveEventOverviewModal.alert.watchRecordingTitle"
      }),
      type: "tip"
    });
  }
  return null;
};
export { LiveEventRegistrationAlert };